import React, { FC, useEffect, useRef, useState } from 'react';

import { styled } from '../theme';

const Wrapper = styled('div')<{
    height: string | number;
    timeout: number;
    style?: React.CSSProperties;
}>(({ theme, height, timeout, style = {} }) => ({
    height: height === 'auto' ? 'auto' : `${height}px`,
    overflow: 'hidden',
    transition: `height ${timeout}ms ease-in-out`,
    ...style,
}));
type Props = {
    in: boolean;
    timeout?: number;
    unmountOnExit?: boolean;
    style?: React.CSSProperties;
};

const Collapse: FC<Props> = ({
    in: inProp,
    children,
    timeout = 300,
    unmountOnExit = false,
    style = {},
    ...otherProps
}) => {
    const [height, setHeight] = useState(0);
    const [isVisible, setIsVisible] = useState(inProp);
    const contentRef = useRef(null);

    useEffect(() => {
        if (inProp) {
            setIsVisible(true);
            requestAnimationFrame(() => {
                if (contentRef.current) {
                    const scrollHeight = contentRef.current.scrollHeight;
                    setHeight(scrollHeight);
                }
            });
        } else {
            if (contentRef.current) {
                const scrollHeight = contentRef.current.scrollHeight;
                setHeight(scrollHeight);
                requestAnimationFrame(() => setHeight(0));
            }
        }
    }, [inProp]);

    const handleTransitionEnd = () => {
        if (!inProp) {
            if (unmountOnExit) {
                setIsVisible(false);
            }
            setHeight(0);
        } else {
            setHeight('auto');
        }
    };

    return (
        (isVisible || !unmountOnExit) && (
            <Wrapper
                height={height}
                timeout={timeout}
                style={style}
                onTransitionEnd={handleTransitionEnd}
                {...otherProps}
            >
                <div ref={contentRef}>{children}</div>
            </Wrapper>
        )
    );
};

export default Collapse;
